// extracted by mini-css-extract-plugin
export default {"SocialIcons":"SocialIcons_SocialIcons__ZU2kQ"};